import React, { Component, createContext  } from 'react';
import { Outlet } from 'react-router-dom';
import { connect } from 'react-redux';
import * as reducers from '../store/reducers';
import { Bling as GPT } from 'react-gpt';
import { getSlug, SUB_1ST_GRADE_SLUGS } from 'Components/AdSlot/getAdData';

import SiteHeader from 'Components/SiteHeader';
import SiteFooter from 'Components/SiteFooter';
import BackgroundSkin from 'Containers/BackgroundSkin';
import { initCountry } from '../utils/location';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';
import { withRampWrapper } from '../utils/Playwire/RampWrapper';

import styles from '../styles/Page.scss';


export const CountryContext = createContext(undefined);

const generatePageClasses = ({
  params,
  routeProps,
  errorMessage,
  backgroundSkin,
}) => {
  let pageClasses = 'Page';

  // Add page type and name
  if (routeProps) pageClasses += ` Page--${routeProps.name} Page--${routeProps.type}`;

  // Is it a grade-based landing page?
   if (params.grade) pageClasses += ` Page--grade-${params.grade}`;
   if (routeProps?.name === 'playground')
     pageClasses += ' Page--grade Page--grade-playground';
  if (backgroundSkin) pageClasses += ' Page--background-skin';

  if (errorMessage) pageClasses = 'Page Page--pageNotFound Page--about';

  return pageClasses;
};

GPT.enableSingleRequest();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userCountry: undefined,
    };
  }

  componentDidMount() {

    initCountry()
      .then(country => {
        this.setState({ userCountry: country });
      })
      .catch(e => {});
  }

  componentDidUpdate(prevProps) {
    const { location, params } = this.props;
    if (
      location.action === 'PUSH' &&
      !(params.bookID && params.pageID && prevProps.params.pageID)
    ) {
      window.scrollTo(0, 0);
      // We also need to clear the style and class on the body
      // to clear out background skins.
      window.document.body.setAttribute('style', '');
      window.document.body.setAttribute('class', '');
      // console.log('RAMP:', window.ramp);
      // this.setAdPath(location.pathname);
    }
    this.setAdTags(location.pathname);
  }

  setAdTags(pathname) {
    try {
      const match = pathname.match(/([^\/]*)\/*$/)[1];

      // console.log('sub1stgrade pathname match', match);
      if (
        window.PageOS &&
        window.PageOS.clearAllTags &&
        window.PageOS.setClientTag
      ) {
        // console.log('CLEARING TAGS sub1stgrade');
        window.PageOS.clearAllTags();
        SUB_1ST_GRADE_SLUGS.forEach(slug => {
          if (match === slug) {
            // console.log('SETTING TAG sub1stgrade');
            window.PageOS.setClientTag(1, 'sub1stgrade');
          }
        });
      }
    } catch (error) {
      // console.log('error setting ad tags', error);
    }
  }

  componentWillReceiveProps(nextProps) {
    const oldPath = this.props.location.pathname;
    const newPath = nextProps.location.pathname;

    if (oldPath !== newPath && typeof COMSCORE !== 'undefined') {
      COMSCORE.beacon({
        c1: '2',
        c2: '6035556',
      });
    }
  }

  render() {
    const { backgroundSkin, location } = this.props;
    const { userCountry } = this.state;

    return (
      <CountryContext.Provider value={userCountry}>
        <div className={generatePageClasses(this.props)}>
          <BackgroundSkin backgroundSkin={backgroundSkin} location={location} />
          <SiteHeader />
          {/* {this.props.children} */}
      
          <Outlet />

          <SiteFooter />
        </div>
      </CountryContext.Provider>
    )
  }
}

const mapStateToProps = (state, { location }) => {
  return {
    errorMessage: reducers.getErrorMessage(state),
    backgroundSkin: reducers.getBackgroundSkin(state, location.pathname),
  };
};

const AppComponent = connect(mapStateToProps, false)(App);

export default withRampWrapper(withLocationWrapper(AppComponent));
